'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index$1 = require('../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index = require('../../../../../../_virtual/index.cjs');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var InternalButtonLink_web = require('../../internal/InternalButtonLink/InternalButtonLink.web.cjs');
var Link_web_styles = require('./Link.web.styles.cjs');

/**
 * Visually styled link component
 * Can be either an anchor or button element depending on the props passed in
 *
 * {@link https://aviary.fullscript.io/latest/components/link/web-5i69bTDg | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/Link/Link.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Link = ({ children, href, to, intention = "neutral", hideUnderline = false, hideExternalIcon = false, customCss, ...rest })=>{
    const theme = react.useTheme();
    const linkStyles = [
        Link_web_styles.base,
        Link_web_styles.intentions(theme, intention),
        hideUnderline && Link_web_styles.hideUnderline,
        customCss
    ];
    return /*#__PURE__*/ jsxRuntime.jsxs(InternalButtonLink_web.InternalButtonLink, {
        css: linkStyles,
        href: href,
        to: to,
        ...rest,
        children: [
            children,
            !hideExternalIcon && index.cjsExports.isExternalUrl(href) && /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                css: Link_web_styles.externalIcon,
                icon: index$1.faArrowUpRightFromSquare,
                size: "sm"
            })
        ]
    });
};
Link.displayName = "Link";

exports.Link = Link;
//# sourceMappingURL=Link.web.cjs.map
